import * as eventAllergiesType from "../../action/actiontype/EventAllergiesType/EventAllergiesType";

const EventallergiesReducer = (state = {}, action) => {

    switch (action.type) {

        case eventAllergiesType.EVENT_ALLERGIES_REQUEST_GETBYALL_ID:
            return {
                ...state,
                eventallergiesGetAllIdLoading: true,
                eventallergiesGetAllIdResponse: {},
                eventallergiesGetAllIdError: null,
            }

        case eventAllergiesType.EVENT_ALLERGIES_SUCCESS_GETBYALL_ID:
            return {
                ...state,
                eventallergiesGetAllIdLoading: false,
                eventallergiesGetAllIdResponse: action.payload,
                eventallergiesGetAllIdError: null,
            }
        case eventAllergiesType.EVENT_ALLERGIES_FAILURE_GETBYALL_ID:
            return {
                ...state,
                eventallergiesGetAllIdLoading: false,
                eventallergiesGetAllIdResponse: {},
                eventallergiesGetAllIdError: action.payload,
            }
        case eventAllergiesType.EVENT_ALLERGIES_REQUEST_ADD:
            return {
                ...state,
                eventallergiesAddLoading: true,
                eventallergiesAddResponse: {},
                eventallergiesAddeError: null,
            }
        case eventAllergiesType.EVENT_ALLERGIES_SUCCESS_ADD:
            return {
                ...state,
                eventallergiesAddLoading: false,
                eventallergiesAddResponse: action.payload,
                eventallergiesAddeError: null,
            }
        case eventAllergiesType.EVENT_ALLERGIES_FAILURE_ADD:
            return {
                ...state,
                eventallergiesAddLoading: false,
                eventallergiesAddResponse: {},
                eventallergiesAddeError: action.payload,
            }
        case eventAllergiesType.EVENT_ALLERGIES_REQUEST_UPDATE:
            return {
                ...state,
                eventallergiesUpdateLoading: true,
                eventallergiesUpdateResponse: {},
                eventallergiesUpdateError: null,
            }

        case eventAllergiesType.EVENT_ALLERGIES_SUCCESS_UPDATE:
            return {
                ...state,
                eventallergiesUpdateLoading: false,
                eventallergiesUpdateResponse: action.payload,
                eventallergiesUpdateError: null,
            }
        case eventAllergiesType.EVENT_ALLERGIES_FAILURE_UPDATE:
            return {
                ...state,
                eventallergiesAddLoading: false,
                eventallergiesAddResponse: {},
                eventallergiesAddeError: action.payload,
            }

        case eventAllergiesType.EVENT_ALLERGIES_REQUEST_DELETE:
            return {
                ...state,
                eventallergiesDeleteLoading: true,
                eventallergiesDeleteResponse: {},
                eventallergiesDeleteError: null,
            }

        case eventAllergiesType.EVENT_ALLERGIES_SUCCESS_DELETE:
            return {
                ...state,
                eventallergiesDeleteLoading: false,
                eventallergiesDeleteResponse: action.payload,
                eventallergiesDeleteError: null,
            }
        case eventAllergiesType.EVENT_ALLERGIES_FAILURE_DELETE:
            return {
                ...state,
                eventallergiesDeleteLoading: false,
                eventallergiesDeleteResponse: {},
                eventallergiesDeleteError: action.payload,
            }
        case eventAllergiesType.EVENT_ALLERGIES_REQUEST_GETBYID:
            return {
                ...state,
                eventallergiesGetIdLoading: true,
                eventallergiesGetIdResponse: {},
                eventallergiesGetIdError: null,
            }

        case eventAllergiesType.EVENT_ALLERGIES_SUCCESS_GETBYID:
            return {
                ...state,
                eventallergiesGetIdLoading: false,
                eventallergiesGetIdResponse: action.payload,
                eventallergiesGetIdError: null,
            }
        case eventAllergiesType.EVENT_ALLERGIES_FAILURE_GETBYID:
            return {
                ...state,
                eventallergiesGetIdLoading: false,
                eventallergiesGetIdResponse: {},
                eventallergiesGetIdError: action.payload,
            }

        default:
            return state;
    }


}

export default EventallergiesReducer;